import projects from '../assets/projects.gif'
import hello from '../assets/hello.json'
import devGradient from '../assets/dev_gradient.mp4'

export default {
  projects,
  hello,
  devGradient,
}